/* esm.sh - applesauce-common@5.2.0/dist/helpers/gift-wrap */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/gift-wrap.mjs";
